import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import Home from './Home';
import AdminDashboard from './AdminDashboard';
import ProductsDashboard from './ProductsDashboard';
import ProductDetails from './ProductDetails';
import StoresDashboard from './StoresDashboard';
import ItemsDashboard from './ItemsDashboard';
import VendorsDashboard from './VendorsDashboard';
import InventoryDashboard from './InventoryDashboard';
import CentralInventoryDashboard from './CentralInventoryDashboard';
import ProductionAnalyticsDashboard from './ProductionAnalyticsDashboard';
import ProductionDashboard from './ProductionDashboard';
import IngredientPurchaseHistoryDashboard from './IngredientPurchaseHistoryDashboard';
import IngredientUsageIndexDashboard from './IngredientUsageIndexDashboard';
import IngredientUsageDetailDashboard from './IngredientUsageDetailDashboard';
import ProductionHistoryDashboard from './ProductionHistoryDashboard';
import ProductionBatchesDashboard from './ProductionBatchesDashboard';
import ProductionBatchDetailsDashboard from './ProductionBatchDetailsDashboard';
import ProductionPredictorDashboard from './ProductionPredictorDashboard';
import CombosDashboard from './CombosDashboard';

export default function AppRoutes({ user, firstName, showEmail, setShowEmail, sidebarCollapsed, setSidebarCollapsed, setShowSpotlight, isAdmin }) {
  return (
    <Dashboard 
      user={user} 
      firstName={firstName} 
      showEmail={showEmail} 
      setShowEmail={setShowEmail}
      sidebarCollapsed={sidebarCollapsed}
      setSidebarCollapsed={setSidebarCollapsed}
      setShowSpotlight={setShowSpotlight}
    >
      <Routes>
        {/* Home route */}
        <Route 
          path="/home" 
          element={<Home user={user} isAdmin={isAdmin} />} 
        />

        {/* Admin route (guarded) */}
        <Route
          path="/admin"
          element={isAdmin ? <AdminDashboard /> : <Navigate to="/home" replace />}
        />
        
        {/* Products routes */}
        <Route 
          path="/products" 
          element={<ProductsDashboard />} 
        />
        <Route 
          path="/products/:productId" 
          element={<ProductDetails />} 
        />
        
        {/* Other dashboard routes */}
        <Route 
          path="/inventory" 
          element={<CentralInventoryDashboard />} 
        />
        <Route 
          path="/ingredients" 
          element={<InventoryDashboard />} 
        />
        <Route 
          path="/ingredient-history" 
          element={<IngredientPurchaseHistoryDashboard />} 
        />
        <Route 
          path="/ingredient-usage" 
          element={<IngredientUsageIndexDashboard />} 
        />
        <Route 
          path="/ingredient-usage/:ingredientId" 
          element={<IngredientUsageDetailDashboard />} 
        />
        <Route
          path="/production-history"
          element={<ProductionHistoryDashboard />}
        />
        <Route
          path="/production-history/:productId"
          element={<ProductionBatchesDashboard />}
        />
        <Route
          path="/production-history/batch/:eventId"
          element={<ProductionBatchDetailsDashboard />}
        />
        <Route 
          path="/stores" 
          element={<StoresDashboard />} 
        />
        <Route 
          path="/items" 
          element={<ItemsDashboard />} 
        />
        <Route
          path="/combos"
          element={<CombosDashboard />}
        />
        <Route 
          path="/vendors" 
          element={<VendorsDashboard />} 
        />
        <Route 
          path="/production" 
          element={<ProductionDashboard />} 
        />
        <Route
          path="/production-predictor"
          element={<ProductionPredictorDashboard />}
        />
        <Route 
          path="/analytics" 
          element={<ProductionAnalyticsDashboard />} 
        />
        
        {/* Default redirect to home */}
        <Route path="/" element={<Navigate to="/home" replace />} />
        
        {/* Catch all route - redirect to home */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Dashboard>
  );
}
